function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, toRefs, ref, watch, reactive, onMounted, getCurrentInstance } from "vue";
import SearchBar from "@/components/SearchV3/index.vue";
import searchMixin from "@/mixin/search";
import { tabMapOptions, Operation } from "./label/label-config";
import TreeModular from "@/views/repository/resource/modular/tree-modular.vue";
import TableModular from "./components/table-list.vue";
import LabelDialog from "./components/label-dialog.vue";
import LabelGroupDialog from "./components/table-group-dialog.vue";
import TableGroupModular from "./components/table-group-list.vue";
import Pagination from "@/components/Pagination/index.vue";
import { getTagList, getTagGroupList } from "@/api/material_label";
import { getTreeHeight } from "@/views/repository/resource/config/methods";
import store from "@/store";
import { formValueSearch, formGroupSearch, formValueQuery, formValueColumn } from "./label/label-from";
export default defineComponent({
    name: "material-label",
    mixins: [
        searchMixin
    ],
    components: {
        SearchBar: SearchBar,
        TreeModular: TreeModular,
        TableModular: TableModular,
        TableGroupModular: TableGroupModular,
        Pagination: Pagination,
        LabelDialog: LabelDialog,
        LabelGroupDialog: LabelGroupDialog
    },
    setup: function setup(props) {
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var treeHeight = ref(0);
        var showAdd = ref(false);
        var isRefresh = ref(false);
        var labelVisible = ref(false);
        var labelGroupVisible = ref(false);
        var treeRef = ref();
        var treeParams = reactive({
            group_type: 2
        });
        var checkedRow = ref([]);
        var materialLabel = reactive({
            activeName: "labelValue",
            labelOptions: tabMapOptions
        });
        var fromList = ref(formValueSearch);
        var fromQuery = reactive({
            query: formValueQuery
        });
        var resourceTable = reactive({
            tableColumnConfig: formValueColumn,
            tableList: [],
            listLoading: false,
            tableListTotal: 0,
            tableItemInfo: {
                id: 0,
                operation: Operation.DELETE
            },
            tableGroupItemInfo: {
                id: "",
                operation: Operation.DELETE
            }
        });
        var fromTableList = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(activeName, params) {
                var res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            resourceTable.listLoading = true;
                            _ctx.prev = 1;
                            if (!(activeName === "labelValue")) {
                                _ctx.next = 8;
                                break;
                            }
                            _ctx.next = 5;
                            return getTagList(params);
                        case 5:
                            _ctx.t0 = _ctx.sent;
                            _ctx.next = 11;
                            break;
                        case 8:
                            _ctx.next = 10;
                            return getTagGroupList(params);
                        case 10:
                            _ctx.t0 = _ctx.sent;
                        case 11:
                            res = _ctx.t0;
                            resourceTable.tableList = res.data.data.list || [];
                            resourceTable.tableListTotal = res.data.data.total;
                            resourceTable.listLoading = false;
                            _ctx.next = 20;
                            break;
                        case 17:
                            _ctx.prev = 17;
                            _ctx.t1 = _ctx["catch"](1);
                            resourceTable.listLoading = false;
                        case 20:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        1,
                        17
                    ]
                ]);
            }));
            return function fromTableList(activeName, params) {
                return _ref.apply(this, arguments);
            };
        }();
        var refreshList = function() {
            isRefresh.value = true;
            fromTableList(materialLabel.activeName, fromQuery.query);
        };
        var tabClickHandle = function(tab) {
            var _$ref;
            if ((_$ref = treeRef.value) === null || _$ref === void 0 ? void 0 : _$ref.treeRef) {
                var _$ref1;
                (_$ref1 = treeRef.value) === null || _$ref1 === void 0 ? void 0 : _$ref1.treeRef.setCurrentKey(null);
            }
            checkedRow.value = [];
            fromQuery.query = _objectSpread({}, formValueQuery);
            fromQuery.query.id = "";
            fromQuery.query.group_id = "";
            fromList.value = tab.name === "labelValue" ? formValueSearch : formGroupSearch;
            showAdd.value = tab.name !== "labelValue";
            refreshList();
            isRefresh.value = false;
        };
        var handleNodeId = function(data) {
            fromQuery.query.group_id = data.id;
            root.$route.query.group_id = data.id;
            root.$route.query.level = String(data.level);
            fromQuery.query.page = 1;
            fromQuery.query.level = data.level || "";
            fromTableList(materialLabel.activeName, fromQuery.query);
        };
        var handleSortChange = function(value) {
            fromQuery.query.order = value.prop;
            if (value.order === "descending") {
                fromQuery.query.order = "-" + value.prop;
            }
            refreshList();
        };
        var handleAddGroup = function(data) {
            labelGroupVisible.value = true;
            isRefresh.value = false;
            resourceTable.tableGroupItemInfo = {
                pid: data.id,
                level: Number(data.level),
                operation: Operation.ADDLABEL
            };
        };
        var handleSelectionChange = function(value) {
            checkedRow.value = value;
        };
        var handleClickOperation = function(row, type) {
            labelVisible.value = true;
            resourceTable.tableItemInfo = type === Operation.DELETE ? {
                id: row.id,
                operation: type
            } : Object.assign(row, {
                operation: type
            });
        };
        var handleClickGroupOperation = function(row, type) {
            labelGroupVisible.value = true;
            isRefresh.value = false;
            resourceTable.tableGroupItemInfo = type === Operation.DELETE ? {
                id: row.id,
                operation: type
            } : Object.assign(row, {
                operation: type
            });
        };
        var handleAddLabel = function(id, type) {
            labelVisible.value = true;
            resourceTable.tableItemInfo = {
                id: id,
                operation: type
            };
        };
        watch(function() {
            return root.$route;
        }, function() {
            fromTableList(materialLabel.activeName, fromQuery.query);
        }, {
            immediate: true
        });
        onMounted(function() {
            store.commit("resource/updateActiveTab", 0);
        });
        onMounted(function() {
            watch(function() {
                return resourceTable.tableList;
            }, function() {
                treeHeight.value = getTreeHeight();
            });
        });
        return _objectSpreadProps(_objectSpread({}, toRefs(fromQuery)), {
            treeRef: treeRef,
            treeHeight: treeHeight,
            checkedRow: checkedRow,
            fromList: fromList,
            showAdd: showAdd,
            treeParams: treeParams,
            isRefresh: isRefresh,
            labelVisible: labelVisible,
            labelGroupVisible: labelGroupVisible,
            materialLabel: materialLabel,
            resourceTable: resourceTable,
            refreshList: refreshList,
            tabClickHandle: tabClickHandle,
            handleNodeId: handleNodeId,
            handleAddGroup: handleAddGroup,
            handleAddLabel: handleAddLabel,
            handleSortChange: handleSortChange,
            handleClickOperation: handleClickOperation,
            handleClickGroupOperation: handleClickGroupOperation,
            handleSelectionChange: handleSelectionChange
        });
    }
});
